import { useGet } from "./requestAPI/apiGet"
import { CampaignObject } from "../types/APITypes";

export const useGetCampaigns = () => 
    useGet<CampaignObject[]>({
        url: 'campaign/get-campaigns'
    }); 

    


